import { ActionsCell } from '../../../../Component/Common/Components/DataTable/ActionsCell';
import { DefaultCell } from '../../../../Component/Common/Components/DataTable/DefaultCell';
import { ActionType, TableColumn } from '../../../../Component/Model/Table/Table';
import { EEDashboardReportingTable } from '../../../../Component/Model/Dto/EmploymentEquity/DashboardReporting';
import { TableDateHelper } from '../../../../Component/Model/helpers';

interface DashboardReportRows {
    createdOn: string;
    reportingPeriodStart: string;
    reportingPeriodEnd: string;
    createdBy: string;
    actions: ActionType[];
}

export interface DashboardReportTable {
    columns: Array<TableColumn>;
    rows: Array<DashboardReportRows>;
}

export function DashboardReportsTableMapper(results: EEDashboardReportingTable.DashboardReportingDto[] = [], downloadReport: (id: string) => void, deleteReport: (id: string) => void): DashboardReportTable {
    const columns = [
        { Header: 'Created On', accessor: 'createdOn', Cell: ({ value }: any) => <DefaultCell value={value} /> },
        { Header: 'Reporting Period Start', accessor: 'reportingPeriodStart', Cell: ({ value }: any) => <DefaultCell value={value} /> },
        { Header: 'Reporting Period End', accessor: 'reportingPeriodEnd', Cell: ({ value }: any) => <DefaultCell value={value} /> },
        { Header: 'Created By', accessor: 'createdBy', Cell: ({ value }: any) => <DefaultCell value={value} /> },
        { Header: 'Actions', accessor: 'actions', Cell: ({ value }: any) => <ActionsCell actions={value} />, disableSortBy: true, }
    ];
    
    if (!results || !Array.isArray(results)) {
        console.error("Invalid results provided");
        return { columns: columns, rows: [] };
    }

    if (results.length > 0) {
        const rows: DashboardReportRows[] = results.map((item: EEDashboardReportingTable.DashboardReportingDto) => ({
            createdOn: TableDateHelper(item.createdOn, true) ?? "",
            reportingPeriodStart: item.reportingPeriodStart,
            reportingPeriodEnd: item.reportingPeriodEnd,
            createdBy: item.createdBy,
            actions: [
                { label: 'Download', action: downloadReport, key: item.portalDocumentId.toString(), icon: { color: 'info', name: 'download' } },
                { label: 'Delete', action: deleteReport, key: item.portalDocumentId.toString(), icon: { color: 'error', name: 'delete' } }]
        }));
        return { columns: columns, rows: rows };
    }
    else {
        return { columns: columns, rows: [] };
    }
}


